import { mapGetters } from "vuex";

export default {
  head() {
    const headMeta = [];
    if (this.gtmIntegration?.verification_code) {
      headMeta.push({
        hid: "google-site-verification",
        name: "google-site-verification",
        content: this.gtmIntegration.verification_code,
      });
    }
    return {
      meta: headMeta,
    };
  },
  computed: {
    ...mapGetters({
      gtmIntegration: "general/getGtmIntegration",
    }),
  },
};
